export enum PlanningGroups {
    GATE = "GATE",
}

export enum ContainerPlanningTypeEnum {
    IN = 2 , 
    OUT = 1 ,
    InAndOut = 4
}